import React, { useContext, useMemo, useState } from 'react'
import { useEffect } from 'react';
import { Toast } from 'primereact/toast';
import { addLocale } from 'primereact/api';
import { Toolbar } from 'primereact/toolbar';
import { Button } from 'primereact/button';
import PropTypes from 'prop-types'
import { DataTable } from 'primereact/datatable';
import { Calendar } from 'primereact/calendar';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { InputText } from 'primereact/inputtext';
import { FileUpload } from 'primereact/fileupload';
import { ProgressSpinner } from 'primereact/progressspinner';
import { saveAs } from 'file-saver';
import '../../DataTableDemo.css';
import dateFormat from '../../services/DateFormat.service';
import apis from '../../api';
import { useRef } from 'react';
import "../../utils/tooltip.css"
import { Tooltip } from 'primereact/tooltip';
import useWindowDimensions from '../hooks/useDimensions';
import invDateFormat from '../../services/InvertDateFormat.service';
import { Toolbar as BigToolbar } from 'react-big-calendar/lib/Toolbar';
import InfoIcon from '../InfoIcon/InfoIcon';
import SkeletonTable from '../SkeletonTable/SkeletonTable';
import './UsersManagement.css'
import { Tag } from 'primereact/tag';
import { Dialog } from 'primereact/dialog';
import { Checkbox } from 'primereact/checkbox';
import { TablePaginator } from '../TablePaginator/TablePaginator';

const UsersManagement = () => {

    const [loadPage, setLoadPage] = useState(false)

    const toast = useRef(null);
    const headers = {
        authorization: localStorage.getItem('token')
    }

    addLocale('es', {
        firstDayOfWeek: 1,
        dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
        dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
        monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
        monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
        today: 'Hoy',
        clear: 'Limpiar'
    });

    /*Propiedades de la tabla del componente*/
    const [rowData, setRowData] = useState([]);
    const [rows, setRows] = useState([]);
    const [first2, setFirst2] = useState(0);
    const [rows2, setRows2] = useState(10);
    const [selectedRows, setSelectedRows] = useState(null);
    const [filters1, setFilters1] = useState(null);
    const [globalFilterValue1, setGlobalFilterValue1] = useState('');
    const [registros, setRegistros] = useState([]);

    const [loadingRowsEnable, setLoadingRowsEnable] = useState({})
    const [loadingRowsReset, setLoadingRowsReset] = useState({})

    useEffect(() => {
        getUsers()
    }, [])

    /*Funciones que manejan el comportamiento de la tabla del componente*/
    const onCustomPage2 = (event) => {
        setFirst2(event.first);
        setRows2(event.rows);
    }

    const dropdownOptions = [
        { label: 5, value: 5 },
        { label: 10, value: 10 },
        { label: 20, value: 20 },
        { label: 50, value: 50 },
        { label: 100, value: 100 },
        { label: 200, value: 200 },
        { label: 300, value: 300 },
    ];

    const template2 = TablePaginator(dropdownOptions)

    const renderHeader1 = () => {
        return (
            <div className="flex justify-content-between">
                <Button type="button" icon="pi pi-filter-slash" label="Limpiar filtros" className="p-button-outlined p-button-sm" onClick={clearFilter1} />
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText className="p-inputtext-sm" value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Palabra clave" />
                </span>
            </div>
        )
    }

    const onGlobalFilterChange1 = (e) => {
        /*Filtro global de la tabla*/
        const value = e.target.value;
        let _filters1 = {
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
        };
        _filters1['global'].value = value;

        setFilters1(_filters1);
        setGlobalFilterValue1(value);
    }

    const clearFilter1 = () => {
        initFilters1();
    }

    const initFilters1 = () => {
        /*Filtros de la tabla del componente*/
        setFilters1({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
            'JOB_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'DAY_CSO': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        });
        setGlobalFilterValue1('');
    }

    const header1 = renderHeader1();

    const matchModes = [
        { label: 'COMIENZA CON', value: FilterMatchMode.STARTS_WITH },
        { label: 'CONTIENE', value: FilterMatchMode.CONTAINS },
        { label: 'NO CONTIENE', value: FilterMatchMode.NOT_CONTAINS },
        { label: 'TERMINA CON', value: FilterMatchMode.ENDS_WITH },
        { label: 'IGUAL A', value: FilterMatchMode.EQUALS },
        { label: 'DIFERENTE A', value: FilterMatchMode.NOT_EQUALS }
    ];

    const getUsers = async () => {
        setLoadPage(false)
        const _entity = localStorage.getItem('entity')
        const _client = localStorage.getItem('client')

        try {
            await apis.getSelfUsers(_entity, _client, headers).then(res => {
                let contracts = res.data.USERS
                let contracts_copy = []
                contracts.forEach(contract => {
                    let contract_copy = {
                        ...contract,
                        FULL_CONTRACT: contract.CONTRACT_ID + ' ' + contract.NUMBER_ID + ' ' + contract.NAMES + ' ' + contract.LAST_NAMES,
                    }
                    setLoadingRowsEnable({
                        ...loadingRowsEnable,
                        [contract.CONTRACT_ID]: false
                    })
                    setLoadingRowsReset({
                        ...loadingRowsReset,
                        [contract.CONTRACT_ID]: false
                    })
                    contracts_copy.push(contract_copy)
                })
                setRows(contracts_copy)
                setLoadPage(true)
            })
        }
        catch (err) {
            console.log(err)
            setLoadPage(true)
        }
    }

    const resetUser = async (rowData) => {
        setLoadingRowsReset({
            ...loadingRowsReset,
            [rowData.CONTRACT_ID]: true
        })

        let payload = {
            ENTITY: rowData.ENTITY,
            CLIENT: rowData.CLIENT,
            CONTRACT_ID: rowData.CONTRACT_ID,
            NUMBER_ID: rowData.NUMBER_ID,
            CORPORATE_MAIL: rowData.CORPORATE_MAIL
        }
        try {
            await apis.resetUser(payload, headers).then(res => {
                let msg = res.data.MESSAGE
                setLoadingRowsReset({
                    ...loadingRowsReset,
                    [rowData.CONTRACT_ID]: false
                })
                getUsers()
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: msg });
            })
        }
        catch (err) {
            setLoadingRowsReset({
                ...loadingRowsReset,
                [rowData.CONTRACT_ID]: false
            })
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    const enableUser = async (rowData) => {
        setLoadingRowsEnable({
            ...loadingRowsEnable,
            [rowData.CONTRACT_ID]: true
        })
        const payload = {
            NUMBER_ID: rowData.NUMBER_ID
        }
        try {
            await apis.activateSelfUser(payload, headers).then(res => {
                const msg = res.data.MESSAGE
                setLoadingRowsEnable({
                    ...loadingRowsEnable,
                    [rowData.CONTRACT_ID]: false
                })
                getUsers()
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: msg, sticky: true });
            })
        }
        catch (err) {
            setLoadingRowsEnable({
                ...loadingRowsEnable,
                [rowData.CONTRACT_ID]: false
            })
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    const photoBodyTemplate = (rowData) => {
        const photo = rowData.IMAGES ? rowData.IMAGES : process.env.REACT_APP_PROFILE_PIC;
        return (
            <div className='flex flex-row align-items-center justify-content-between gap-1'>
                <div
                    style={{
                        width: '50px',
                        height: '50px',
                        minWidth: '50px',
                        borderRadius: '50%',
                        overflow: 'hidden',
                        flexShrink: 0
                    }}
                >
                    <img
                        src={photo}
                        alt=""
                        loading="eager"
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover'
                        }}
                    />
                </div>
                <div className='flex flex-column ml-2 text-left w-full'>
                    <span className='font-bold'>{rowData.NAMES} {rowData.LAST_NAMES}</span>
                    <span>C.C.: {rowData.NUMBER_ID}</span>
                    <span>Contrato: {rowData.CONTRACT_ID}</span>
                </div>
            </div>
        );
    }

    const actionBodyTemplate = (rowData) => {
        return (
            <div style={{ width: "10rem" }}>
                <Button icon="pi pi-user-plus" className="p-button-success mr-1 p-button-sm text-xs" tooltip="Crear autogestión" tooltipOptions={{ position: 'top' }}
                    loading={loadingRowsEnable[rowData.CONTRACT_ID]} onClick={() => enableUser(rowData)} disabled={rowData.SELFSERVICE === 'SI'} />
                <Button icon="pi pi-undo" className="p-button-sm text-xs" tooltip="Reenviar credenciales" tooltipOptions={{ position: 'top' }}
                    loading={loadingRowsReset[rowData.CONTRACT_ID]} onClick={() => resetUser(rowData)} disabled={rowData.SELFSERVICE === 'NO'} />
            </div>
        )
    }

    const headerTemplate = () => {
        return (
            <div className='flex w-full gap-2 justify-content-between align-items-center'>
                <span>Acciones</span>
                <Button icon="pi pi-sync" className="p-button-sm text-xs" tooltip="Actualizar" tooltipOptions={{ position: 'top' }}
                    onClick={() => getUsers()} />
            </div>
        )
    }

    return (
        <div className='surface-100 px-4 py-5 md:px-6 lg:px-8r'>
            <Toast ref={toast} />
            <div className="flex flex-row align-items-center justify-content-center mb-3 font-bold text-4xl mt-6">
                <span className="text-900">Gestión de usuarios</span>
            </div>
            <div className='mt-6 w-full'>
                <SkeletonTable load={loadPage}>
                    {/* <Toolbar start={leftToolbarTemplate} end={rightToolbarTemplate} className='card flex flex-row' /> */}
                    <div className="thing3">
                        <Tooltip target=".info" className='indigo-tooltip ml-1' />
                        <DataTable className="card text-xs" value={rows} first={first2} rows={rows2} scrollable scrollDirection='horizontal'
                            dataKey="CONTRACT_ID" size="small" style={{ width: '100%' }} paginator paginatorTemplate={template2} filterLocale='es'>
                            <Column headerStyle={{ width: '3em' }}></Column>
                            <Column header="Empleados" field='FULL_CONTRACT' filterMatchModeOptions={matchModes} body={photoBodyTemplate} style={{ width: '20rem' }} filter></Column>
                            <Column field="ENTITY_NAME" filter filterMatchModeOptions={matchModes} header='Entidad'></Column>
                            <Column field="CLIENT_NAME" filter filterMatchModeOptions={matchModes} header="Cliente"></Column>
                            <Column field="CORPORATE_MAIL" filter filterMatchModeOptions={matchModes} header="Correo"></Column>
                            <Column field="SELFSERVICE" filter filterMatchModeOptions={matchModes} header="Autogestión"></Column>
                            <Column field="STATUS" filter filterMatchModeOptions={matchModes} header="Estado"></Column>
                            <Column body={actionBodyTemplate} header={headerTemplate}></Column>
                        </DataTable>
                    </div>
                </SkeletonTable>
            </div>
        </div>
    )

}

export default UsersManagement